// Starts a background AI job on the backend and polls until it finishes
export const runAiJob = async (api, path, body, { interval = 2500, timeout = 180000, jobId: existing } = {}) => {
  const jobId = existing || (await api.post(path, body)).data.job_id;
  const started = Date.now();
  while (Date.now() - started < timeout) {
    await new Promise((r) => setTimeout(r, interval));
    const { data } = await api.get(`/ai-jobs/${jobId}`);
    if (data.status === 'completed') return data.result;
    if (data.status === 'failed') throw new Error(data.error || 'La IA no pudo completar la tarea');
  }
  throw new Error('La IA tardó demasiado. Intenta nuevamente.');
};
